import React from "react";
import { useNavigate } from "react-router-dom";
import CustomViewButton from "../../../CustomComponent/custom_view_button";

const tableHead = [
  "Sr.",
  " Order Date",
  "full name & Contact Number",
  "Order owner",
  "Kit status",
  "Actions",
];

const AllKitTrackingTable = ({
  kitTracking = [],
  currentPage,
  itemsPerPage,
}) => {
  const navigate = useNavigate();
  const goToView = (id) => {
    navigate(`/kitTracking/view/${id}`);
  };

  return (
    <div className="table-responsive">
      <table className="table table-vcenter">
        <thead>
          <tr>
            {tableHead?.map((item, index) => {
              return <th key={index}>{item}</th>;
            })}
          </tr>
        </thead>
        <tbody>
          {kitTracking?.map((item, index) => {
            const Index = (currentPage - 1) * itemsPerPage + index + 1;

            return (
              <tr>
                <td>{Index}</td>
                <td>{item.orderDate}</td>
                <td>
                  {item?.clientName || "N/A"} <br />{" "}
                  <span className="text-secondary badge bg-cyan-lt">
                    {item?.clientContactNumber || "N/A"}
                  </span>
                </td>
                <td>{item?.generatedBy || "N/A"}</td>
                <td>{item?.kitStatus || "N/A"}</td>
                <td>
                  <CustomViewButton
                    onClick={() => goToView(item.id)}
                  ></CustomViewButton>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default AllKitTrackingTable;
